export const AuthAlumnatEstranger = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Alumnat provinents d'estudis estrangers
        </h4>
        <p>

          En cas de ser un alumnat provinent d'estudis estrangers al batxillerat o FP, cal que l'alumne/a presenti la credencial d'homologació del títol corresponent, i el volant de matrícula condicional que indica que ha iniciat el tràmit de l'expedient d'homologació. En cas que no acrediti la convalidació o homologació abans de final de curs no es podrà avaluar l'alumne/a, i no passarà de curs

          <br />
          <br />


          <label htmlFor="authAlumnatEstranger1">
            <input type="radio" id="authAlumnatEstranger1" name="authAlumnatEstranger" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange("1") }} required />
            Estic assabentat que si no acredito abans de final de curs aquesta documentació, no podré ser avaluat/da i no podré passar de curs.
          </label>

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

          <br />

          <label htmlFor="authAlumnatEstranger0">
            <input type="radio" id="authAlumnatEstranger0" name="authAlumnatEstranger" value={auth} checked={auth === "0" ? true : false} onChange={(t) => { handleChange("0") }} required />
            Aquest no és el cas que m'ocupa, atès que no provinc d'estudis estrangers de batxillerat o formació professional
          </label>

          <br />

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

        </p>


      </div>
    </div>

    <br />

  </>)
}
